module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1053-9cf44e12585324c2b29841c5f06ae25f.png";